// extracted by mini-css-extract-plugin
module.exports = {"nudge":"_58c7ab8"};